import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import AppLayout from '../../components/ui/AppLayout';
import PageHeader from '../../components/ui/PageHeader';
import SectionCard from '../../components/ui/SectionCard';
import PriceList from './PriceList';

const ConfirmationPage = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [copied, setCopied] = useState(false);
  const chavePix = '00020101021126900014br.gov.bcb.pix0136740ea0ee-40b5-4bf9-9df3-be0dd67419820228inscricao  6 torneio riviera5204000053039865802BR5922FERNANDO J DE M JUNIOR6006RECIFE62070503***6304A576';

  const handleCopyClick = async () => {
    await navigator.clipboard.writeText(chavePix);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDialog(true);
    }, 15000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AppLayout maxWidth="md">
      <PageHeader eyebrow="Torneio" title="Pagamento da inscrição" subtitle="Sua vaga é confirmada após a validação do pagamento." />
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <SectionCard title="Pague com PIX">
            <Stack alignItems="center" spacing={2}>
              <Box sx={{ p: 1.5, border: 1, borderColor: 'divider', borderRadius: 3, bgcolor: '#fff' }}>
                <Box component="img" src="/image/pix_torneio.png" alt="QR Code PIX" sx={{ width: 220, height: 220, display: 'block' }} />
              </Box>
              <Button variant="contained" fullWidth startIcon={<ContentCopyRoundedIcon />} onClick={handleCopyClick}>
                {copied ? 'Código copiado!' : 'Copiar PIX copia e cola'}
              </Button>
            </Stack>
          </SectionCard>
        </Grid>
        <Grid item xs={12} md={7}>
          <Stack spacing={2}>
            <Alert severity="info">Depois de pagar, envie o comprovante para a organização para concluir a inscrição.</Alert>
            <Typography variant="h6">Valores</Typography>
            <PriceList />
          </Stack>
        </Grid>
      </Grid>

      <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
        <DialogTitle>Atenção</DialogTitle>
        <DialogContent>
          <DialogContentText>
            O pagamento será validado e a inscrição concluída. Por favor, envie o comprovante para o organizador.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setShowDialog(false)} variant="contained">Ok</Button>
        </DialogActions>
      </Dialog>
    </AppLayout>
  );
};

export default ConfirmationPage;
